<template>
	<div class="cb">
		<div class="ly-muted mb-4">
			Testi e foto dei blocchi della home Boutique. Un blocco senza titolo non compare sul sito. Le foto si caricano qui; i pulsanti portano all'indirizzo indicato (es. /intimo o una pagina esterna).
		</div>

		<div class="cb-blocco">
			<div class="cb-titolo"><v-icon small class="mr-2">mdi-format-align-top</v-icon>Barra in alto</div>
			<div class="ly-muted mb-2">Accanto al messaggio sopra l'header: un testo a sinistra e uno a destra (es. «Negozio di famiglia dal 1970», «Assistenza su WhatsApp»).</div>
			<TestiLingua
				:trans="contenuti.topbar_left.trans"
				titolo="Testo a sinistra"
				@copia="id => $emit('copia', contenuti.topbar_left.trans, id)"
				@traduci="(id, lang) => $emit('traduci', contenuti.topbar_left.trans, id, lang)"
			/>
			<TestiLingua
				:trans="contenuti.topbar_right.trans"
				titolo="Testo a destra"
				@copia="id => $emit('copia', contenuti.topbar_right.trans, id)"
				@traduci="(id, lang) => $emit('traduci', contenuti.topbar_right.trans, id, lang)"
			/>
		</div>

		<div v-for="b in blocchi" :key="b.key" class="cb-blocco">
			<div class="cb-titolo">
				<v-icon small class="mr-2">{{ b.icona }}</v-icon
				>{{ b.label }}
			</div>
			<div class="ly-muted mb-2">{{ b.aiuto }}</div>

			<div class="cb-foto">
				<div class="cb-anteprima">
					<img v-if="contenuti[b.key].image" :src="contenuti[b.key].image" :alt="b.label" />
					<v-icon v-else large color="grey lighten-1">mdi-image-outline</v-icon>
				</div>
				<div class="d-flex flex-column" style="gap: 6px">
					<v-btn small outlined color="primary" @click="$emit('carica', 'boutique.' + b.key)"><v-icon left small>mdi-upload</v-icon>{{ contenuti[b.key].image ? 'Cambia foto' : 'Carica foto' }}</v-btn>
					<v-btn v-if="contenuti[b.key].image" small text color="error" @click="$emit('imposta', b.key, 'image', '')"><v-icon left small>mdi-delete-outline</v-icon>Togli foto</v-btn>
				</div>
			</div>

			<template v-for="c in b.campi">
				<TestiLingua
					:key="b.key + c.key"
					:trans="contenuti[b.key][c.key].trans"
					:titolo="c.label"
					:placeholder="c.placeholder"
					:textarea="!!c.textarea"
					@copia="id => $emit('copia', contenuti[b.key][c.key].trans, id)"
					@traduci="(id, lang) => $emit('traduci', contenuti[b.key][c.key].trans, id, lang)"
				/>
			</template>
			<div class="cb-link">
				<v-text-field
					v-for="l in b.link"
					:key="l.key"
					:value="contenuti[b.key][l.key]"
					@input="v => $emit('imposta', b.key, l.key, v)"
					:label="l.label"
					:placeholder="l.placeholder"
					outlined
					dense
					hide-details
				/>
			</div>
		</div>
	</div>
</template>

<script>
import TestiLingua from './TestiLingua.vue';

// blocchi della home Boutique: per ogni testo una voce per lingua ({ trans: [{ lang, message }] }, come TestiLingua),
// foto e indirizzi senza lingua. La struttura completa la prepara contenutiBoutique() in Layout.vue
export const BLOCCHI_BOUTIQUE = [
	{
		key: 'hero',
		label: 'Apertura della home',
		icona: 'mdi-image-text',
		aiuto: 'Prende il posto dello slider: testo grande a sinistra e foto verticale a destra. Senza titolo resta lo slider.',
		campi: [
			{ key: 'eyebrow', label: 'Occhiello', placeholder: 'Es. Nuova stagione · Intimo donna' },
			{ key: 'title', label: 'Titolo', placeholder: 'Es. La morbidezza di tutti i giorni, scelta con cura dal 1970' },
			{ key: 'text', label: 'Testo', textarea: true },
			{ key: 'cta1_label', label: 'Pulsante principale', placeholder: "Es. Scopri l'intimo" },
			{ key: 'cta2_label', label: 'Secondo pulsante', placeholder: 'Es. Biancheria per la casa' },
		],
		link: [
			{ key: 'cta1_url', label: 'Indirizzo del pulsante principale', placeholder: '/intimo' },
			{ key: 'cta2_url', label: 'Indirizzo del secondo pulsante', placeholder: '/biancheria-letto' },
		],
	},
	{
		key: 'feature',
		label: 'Blocco in evidenza',
		icona: 'mdi-bed-outline',
		aiuto: "Testo e foto affiancati dopo le prime fasce di prodotti (es. «Biancheria per la casa»). Con l'indirizzo di una categoria compaiono anche le sue sottocategorie.",
		campi: [
			{ key: 'eyebrow', label: 'Occhiello', placeholder: 'Es. Biancheria per la casa' },
			{ key: 'title', label: 'Titolo', placeholder: 'Es. Lenzuola, piumini e spugne per riposare meglio' },
			{ key: 'text', label: 'Testo', textarea: true },
			{ key: 'cta_label', label: 'Pulsante', placeholder: 'Es. Scopri la biancheria' },
		],
		link: [{ key: 'cta_url', label: 'Indirizzo (categoria o pagina)', placeholder: '/biancheria-letto' }],
	},
	{
		key: 'story',
		label: 'La nostra storia',
		icona: 'mdi-storefront-outline',
		aiuto: 'Fascia scura con la foto del negozio, prima dei marchi.',
		campi: [
			{ key: 'eyebrow', label: 'Occhiello', placeholder: 'Es. La nostra storia' },
			{ key: 'title', label: 'Titolo', placeholder: 'Es. Dal 1970, una bottega di famiglia' },
			{ key: 'text', label: 'Testo', textarea: true },
			{ key: 'cta_label', label: 'Pulsante', placeholder: 'Es. Chi siamo' },
		],
		link: [{ key: 'cta_url', label: 'Indirizzo del pulsante', placeholder: '/chi-siamo' }],
	},
];

export default {
	name: 'ContenutiBoutique',
	components: { TestiLingua },
	props: {
		// form.layout.theme.boutique, gia' completo per tutte le lingue
		contenuti: { type: Object, required: true },
	},
	data() {
		return { blocchi: BLOCCHI_BOUTIQUE };
	},
};
</script>

<style scoped>
.cb-blocco {
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding: 16px 0;
	border-top: 1px solid #eef2f7;
}
.cb-titolo {
	font-weight: 600;
	font-size: 15px;
	display: flex;
	align-items: center;
}
.cb-foto {
	display: flex;
	align-items: center;
	gap: 14px;
}
.cb-anteprima {
	width: 96px;
	height: 120px;
	border-radius: 4px;
	background: #f5f7fa;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
}
.cb-anteprima img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.cb-link {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
	gap: 10px;
}
</style>
